import { roles } from '@nxsys/store/constants';
import KIDListingScreen from '../../../modules/kid/Listing';
import ComingSoon from '../../../modules/errorPages/ComingSoon';

export const kidConfig = [
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: "/kid",
    element: <KIDListingScreen />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: "/kid/:activeTab",
    element: <ComingSoon />,
  },
];
